class Inventory{

}

export {Inventory}